import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./fonts/pretendardvariable.css";
// import "https://kit.fontawesome.com/4ba16c70d5.js";
import App from "./App";
import "./i18/i18n"; // 다국어 지원
// import HttpsRedirect from "react-https-redirect";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <HttpsRedirect> */}
    <App />
    {/* </HttpsRedirect> */}
  </React.StrictMode>
);
